var multisharer_markup = '<div class="dzsvg-main-con skin-default gallery-skin-default transition-slideup "> <div class="overlay-background"></div> <div class="box-mains-con"> <div class="box-main" style=""> <div class="box-main-media-con transition-target"> <div class="close-btn-con"> <svg enable-background="new 0 0 40 40" id="" version="1.1" viewBox="0 0 40 40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M28.1,26.8c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-6.8-6.8l-6.8,6.8c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6.8-6.8l-6.8-6.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.8,6.8l6.8-6.8 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L21.3,20L28.1,26.8z"></path></g><g><path d="M19.9,40c-11,0-20-9-20-20s9-20,20-20c4.5,0,8.7,1.5,12.3,4.2c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.4-1,0.5-1.4,0.2 c-3.2-2.5-7-3.8-11-3.8c-9.9,0-18,8.1-18,18s8.1,18,18,18s18-8.1,18-18c0-3.2-0.9-6.4-2.5-9.2c-0.3-0.5-0.1-1.1,0.3-1.4 c0.5-0.3,1.1-0.1,1.4,0.3c1.8,3.1,2.8,6.6,2.8,10.2C39.9,31,30.9,40,19.9,40z"></path></g></svg></div> <div class="box-main-media type-inlinecontent" style="width: 530px; height: 280px;"><div class=" real-media" style=""><div class="hidden-content share-content" > <div class="social-networks-con"></div> <div class="share-link-con"></div> <div class="embed-link-con embed-link-con-for-dzsvg"></div> </div> </div> </div> <div class="box-main-under"></div> </div> </div> </div><!-- end .box-mains-con--> </div>';

var ConstantsDzsvg = require('../configs/Constants').constants;

function version_firefox() {
  if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
    var aversion = new Number(RegExp.$1);
    return (aversion);
  }
  ;
}
;

function get_query_arg(purl, key) {
  if (purl.indexOf(key + '=') > -1) {
    //faconsole.log('testtt');
    var regexS = "[?&]" + key + "=.+";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);
    //console.info(regtest);

    if (regtest != null) {
      var splitterS = regtest[0];
      if (splitterS.indexOf('&') > -1) {
        var aux = splitterS.split('&');
        splitterS = aux[1];
      }
      //console.log(splitterS);
      var splitter = splitterS.split('=');
      //console.log(splitter[1]);
      //var tempNr = ;

      return splitter[1];

    }
    //$('.zoombox').eq
  }
}

function can_translate() {
  if (is_chrome() || is_safari()) {
    return true;
  }
  if (is_firefox() && version_firefox() > 10) {
    return true;
  }
  return false;
}


function is_safari() {
  return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
}
;


function is_android() {


  var ua = navigator.userAgent.toLowerCase();
  return (ua.indexOf("android") > -1);
}

function is_touch_device() {
  //return true;
  return !!('ontouchstart' in window);
}

function can_history_api() {
  return !!(window.history && history.pushState);
}

function add_query_arg(purl, key, value) {
  key = encodeURIComponent(key);
  value = encodeURIComponent(value);

  var s = purl;
  var pair = key + "=" + value;

  var r = new RegExp("(&|\\?)" + key + "=[^\&]*");

  s = s.replace(r, "$1" + pair);
  //console.log(s, pair);
  if (s.indexOf(key + '=') > -1) {


  } else {
    if (s.indexOf('?') > -1) {
      s += '&' + pair;
    } else {
      s += '?' + pair;
    }
  }
  //if(!RegExp.$1) {s += (s.length>0 ? '&' : '?') + kvp;};


  //if value NaN we remove this field from the url
  if (value == 'NaN') {
    var regex_attr = new RegExp('[\?|\&]' + key + '=' + value);
    s = s.replace(regex_attr, '');
  }

  return s;
}


function is_ios() {
  // return true;
  return ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1 || (navigator.platform.indexOf("MacIntel") != -1 && is_touch_device()))
  );
}

function fullscreen_status() {
  if (document.fullscreenElement!==null) {
    return 1;
  } else if (document.webkitFullscreenElement) {

    return 1;
  } else if (document.mozFullScreenElement) {
    return 1;
  } else return 0;
}


function is_chrome() {
  return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
}
;

exports.dzsvg_call_video_when_ready = function (o, _videoElement, init_readyVideo, vimeo_is_ready, inter_videoReadyState) {


  // console.log('check_videoReadyState', video, '_videoElement.readyState - ', _videoElement.readyState, 'o.type - ', o.type);


  if (o.type == 'youtube' && _videoElement.getPlayerState) {

    init_readyVideo();
  }

  // console.info('_videoElement.readyState - ',   _videoElement.readyState);


  if (is_firefox() && o.cueVideo != 'on' && (o.type == 'selfHosted' || o.type == 'audio') && Number(_videoElement.readyState) >= 2) {
    init_readyVideo({
      'called_from': 'check_videoReadyState'
    });
    return false;
  }


  if (o.type == 'vimeo' && o.vimeo_is_chromeless == 'on') {

    if (vimeo_is_ready) {
      init_readyVideo();
      return false;
    }
  }
  if (o.type == 'audio') {
    if (is_mobile()) {
      if (Number(_videoElement.readyState) >= 1) {

        init_readyVideo();
        return false;
      }
    }


    if (Number(_videoElement.readyState) >= 3) {
      clearInterval(inter_videoReadyState);
      init_readyVideo({
        'called_from': 'check_videoReadyState'
      });
      return false;
    }
  }
  if (o.type == 'selfHosted') {

    // console.log('navigator.platform - ', navigator.platform);
    if (is_ios()) {
      // console.log('ios - readyState - ', Number(_videoElement.readyState));
      if (Number(_videoElement.readyState) >= 1) {

        init_readyVideo();
        return false;
      }
    }

    if (is_android()) {
      if (Number(_videoElement.readyState) >= 2) {

        init_readyVideo();
        return false;
      }
    }


    if (Number(_videoElement.readyState) >= 3 || o.preload_method == 'none') {
      clearInterval(inter_videoReadyState);
      init_readyVideo({
        'called_from': 'check_videoReadyState'
      });
      return false;
    }
  }


  // --- WORKAROUND __ for some reason ios default browser would not go over video ready state 1

  if (o.type == 'dash') {
    //console.warn(_videoElement.readyState)
    clearInterval(inter_videoReadyState)
    init_readyVideo({
      'called_from': 'check_videoReadyState'
    });
  }


}

function dzsvg_click_open_embed_ultibox() {
  // -- this is used for video gallery
  // -- @triggered on clicking multisharer button in dzsvg


  // console.info('ceva');

  var _c = jQuery('.dzsvg-main-con').eq(0);

  // console.info('_c -> ',_c, cgallery.find('.feed-dzsvg--for-social-networks').eq(0).html(), _c.find('.social-networks-con'));


  var _t = jQuery(this);
  var _vg = null
    , _vp = null
  ;

  console.log('_t -dzsvg_click_open_embed_ultibox()- ', _t, _t.parent().parent().parent());


  var _par_par_par = _t.parent().parent().parent();
  // -- if this is a button in video player ?
  if (_par_par_par.hasClass('vplayer')) {
    _vp = _par_par_par;
  }
  // -- if this is a button in video gallery ?
  if (_par_par_par.hasClass('videogallery')) {
    _vg = _par_par_par;
  }

  var aux = '';

  if (window.dzsvg_social_feed_for_social_networks) {
    aux = window.dzsvg_social_feed_for_social_networks;
  }


  aux = aux.replace(/&quot;/g, '\'');
  aux = aux.replace('onclick=""', '');

  _c.find('.social-networks-con').html(aux);


  aux = '';


  if (window.dzsvg_social_feed_for_share_link) {
    aux = window.dzsvg_social_feed_for_share_link;
  }


  if (aux) {

    aux = aux.replace('{{replacewithcurrurl}}', window.location.href);
    _c.find('.share-link-con').html(aux);
  }

  aux = '';
  if (window.dzsvg_social_feed_for_embed_link) {
    aux = window.dzsvg_social_feed_for_embed_link;
  }


  // console.info('%c embed', 'background-color: #eee;', 'dzsvg_social_feed_for_embed_link - ',aux);
  // console.info('_vp - ',_vp, '_vg - ',  _vg);

  // -- for single video player
  if ((_vp || _vg) && aux) {

    if (_vp && _vp.data('embed_code')) {
      jQuery('.embed-link-con').show();
      aux = aux.replace('{{replacewithembedcode}}', htmlEntities(_vp.data('embed_code')));

      // console.info('_c.find(\'.embed-link-con\') - ',_c.find('.embed-link-con'));
      _c.find('.embed-link-con').html(aux);
    } else {


      if (_vg && aux) {

        var iframe_code = '<div style="width: 100%; padding-top: 67.5%; position: relative;"><iframe src=\'' + dzsvg_settings.dzsvg_site_url + '?action=embed_dzsvg&type=' + 'gallery' + '&id=' + _vg.attr('data-dzsvg-gallery-id') + '\'  width="100%" style="position:absolute; top:0; left:0; width: 100%; height: 100%;" scrolling="no" frameborder="0" allowfullscreen allow></iframe>';

        var encodedStr = String(iframe_code).replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
          return '&#' + i.charCodeAt(0) + ';';
        });
        aux = aux.replace('{{replacewithembedcode}}', encodedStr);

        // -- inspired from php @generate_embed_code
        _c.find('.embed-link-con').html(aux);
      } else {

        // -- hide embed link if we do not have embed_code
        jQuery('.embed-link-con').hide();
      }
    }
  }


  jQuery(document).on('click.dzsvg', '.field-for-view', function () {

    // console.info("HMM ", this);
    // selectText(this);

    jQuery(this).select();
  });
  setTimeout(function () {

    _c.addClass('loading-item');
  }, 100);

  setTimeout(function () {
    _c.addClass('loaded-item');
  }, 200);
}


function get_base_url_arr() {


  var scripts = document.getElementsByTagName("script");


  for (var i23 in scripts) {
    if (scripts[i23] && scripts[i23].src && String(scripts[i23].src).indexOf('vplayer.js') > -1) {

      break;
    }
  }
  var baseUrl_arr = String(scripts[i23].src).split('/');

  return baseUrl_arr;
}


function dzsvg_check_multisharer() {
  // console.info("LOAD MULTISHARER");


  setTimeout(function () {


    jQuery('body').append(multisharer_markup);


  }, 1000);


  jQuery(document).on('click.dzsvg', '.dzsvg-main-con .close-btn-con,.dzsvg-main-con .overlay-background', function () {

    var _c = jQuery('.dzsvg-main-con').eq(0);

    _c.removeClass('loading-item loaded-item');
  })

  jQuery(document).on('click.dzsvg', '.dzsvg-multisharer-but', dzsvg_click_open_embed_ultibox);
  jQuery(document).on('click.dzsvg', '.dzsvg-main-con .close-btn-con,.dzsvg-main-con .overlay-background', function () {

    var _c = jQuery('.dzsvg-main-con').eq(0);

    _c.removeClass('loading-item loaded-item');
  })


}


function is_mobile() {
  // return true;
  return is_ios() || is_android();
}

function is_firefox() {
  if (navigator.userAgent.indexOf("Firefox") != -1) {
    return true;
  }
  ;
  return false;
}
;

exports.sanitize_to_youtube_id = function (arg) {
  var fourArr = null;

  // console.info('arg - ',arg);
  if (arg) {

    if (arg.indexOf('youtu.be') > -1) {
      fourArr = arg.split('/');


      if (fourArr[fourArr.length - 1] == '') {
        return fourArr[fourArr.length - 2];
      } else {
        return fourArr[fourArr.length - 1];
      }
    }

  }

  return arg;

}

exports.getDataOrAttr = function (_c, attr) {
  if (_c.data && typeof _c.data(attr) != 'undefined') {
    return _c.data(attr);
  }
  if (_c.attr && typeof _c.attr(attr) != 'undefined') {
    return _c.attr(attr);
  }

  return null;
}
exports.detect_videoTypeAndSourceForElement = function (_el) {

  if(_el.data('originalPlayerAttributes')){
    return _el.data('originalPlayerAttributes');
  }

  var dataSrc = this.getDataOrAttr(_el, 'data-sourcevp');

  var forceType = this.getDataOrAttr(_el, 'data-type') ? this.getDataOrAttr(_el, 'data-type') : '';

  return this.detect_video_type_and_source(dataSrc, forceType)
}
/**
 * detect video type and source
 * @param dataSrc
 * @param forceType we might want to force the type if we know it
 * @returns {{source: *, playFrom: null, type: string}}
 */
exports.detect_video_type_and_source = function (dataSrc, forceType=null) {

  // console.log('dataSrc -> ', dataSrc, String(dataSrc).indexOf('youtube.com/watch?') > -1 || String(dataSrc).indexOf('youtube.com/embed') > -1 || String(dataSrc).indexOf('https://youtu.be/') > -1 || String(dataSrc).indexOf('https://youtu.be/') > -1);

  var playFrom = null;
  var type = 'selfHosted';
  var source = dataSrc;
  if (String(dataSrc).indexOf('youtube.com/watch?') > -1 || String(dataSrc).indexOf('youtube.com/embed') > -1 || String(dataSrc).indexOf('youtu.be/') > -1) {
    type = 'youtube';

    var aux = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/g.exec(dataSrc);
    // console.log('aux -7 ', aux);

    if (get_query_arg(dataSrc, 't')) {
      playFrom = get_query_arg(dataSrc, 't');
    }
    if (aux && aux[1]) {
      source = aux[1];
    } else {
      // -- let us try youtube embed
      source = dataSrc.replace(/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/|be\.com)\/embed\//g, '');
    }

  }

  if (String(dataSrc).indexOf('vimeo.com/') > -1) {
    type = 'vimeo';

    var aux = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/g.exec(dataSrc);


    if (aux && aux[1]) {
      source = aux[1];
    }
  }

  if (String(dataSrc).indexOf('.mp4') > -1) {
    type = 'selfHosted';

  }
  if (String(dataSrc).indexOf('.mpd') > String(dataSrc).length - 5) {
    type = 'dash';

  }
  if(forceType && forceType!='detect'){
    type = forceType;
  }
  return {
    type,
    source,
    playFrom
  };
}

exports.sanitizeDataAdArrayStringToArray = function (aux) {

  var ad_array = null;
  try {


    // temp - try to remove slashes manually
    aux = aux.replace(/{\\"/g, '{"');
    aux = aux.replace(/\\":/g, '":');
    aux = aux.replace(/:\\"/g, ':"');
    aux = aux.replace(/\\",/g, '",');
    aux = aux.replace(/\\"}/g, '"}');
    aux = aux.replace(/,\\"/g, ',"');
    ad_array = JSON.parse(aux);
  } catch (err) {
    console.log('ad array parse error', aux);
  }

  return ad_array;


}

exports.is_autoplay_and_muted = function (autoplay, o) {

  return ((1) && autoplay == 'on' && o.autoplay_on_mobile_too_with_video_muted == 'on' && o.user_action == 'not_yet') || (o.defaultvolume == 0 && o.defaultvolume !== '');

}

exports.dzsvg_check_multisharer = dzsvg_check_multisharer;
exports.get_base_url_arr = get_base_url_arr;
exports.dzsvg_click_open_embed_ultibox = dzsvg_click_open_embed_ultibox;
exports.fullscreen_status = fullscreen_status;
exports.can_history_api = can_history_api;
exports.get_query_arg = get_query_arg;
exports.is_ios = is_ios;
exports.is_android = is_android;
exports.is_safari = is_safari;
exports.is_mobile = is_mobile;
exports.is_touch_device = is_touch_device;
exports.can_translate = can_translate;
exports.add_query_arg = add_query_arg;
exports.multisharer_markup = multisharer_markup;


exports.setup_videogalleryCategories = function (arg) {
  var ccat = jQuery(arg);
  var currCatNr = -1;
  //console.log(ccat);
  ccat.find('.gallery-precon').each(function () {
    var _t = jQuery(this);
    //console.log(_t);
    _t.css({'display': 'none'});
    ccat.find('.the-categories-con').append('<span class="a-category">' + _t.attr('data-category') + '</span>')
  });

  ccat.find('.the-categories-con').find('.a-category').eq(0).addClass('active');
  ccat.find('.the-categories-con').find('.a-category').bind('click', click_category);

  function click_category() {
    var _t = jQuery(this);
    var ind = _t.parent().children('.a-category').index(_t);

    //console.warn('ind - ',ind);
    gotoCategory(ind);
    setTimeout(function () {
      jQuery(window).trigger('resize');
    }, 100);
  }

  //console.info(ccat);

  var i2 = 0;

  ccat.find('.gallery-precon').each(function () {
    var _t = jQuery(this);

    //console.info(_t);

    _t.find('.pagination-number').each(function () {
      var _t2 = jQuery(this);
      //console.log(_t2);

      var auxurl = _t2.attr('href');

      //console.log(auxurl);

      auxurl = helpersDZSVG.add_query_arg(auxurl, ccat.attr('id') + '_cat', NaN);

      //console.log(auxurl);

      auxurl = helpersDZSVG.add_query_arg(auxurl, ccat.attr('id') + '_cat', i2);

      _t2.attr('href', auxurl);
    })

    i2++;
  })

  var tempCat = 0;

  //console.info(window.location.href, ccat.attr('id')+'_cat', helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id')+'_cat'))

  if (helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id') + '_cat')) {
    tempCat = Number(helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id') + '_cat'));
  }


  ccat.get(0).api_goto_category = gotoCategory;

  gotoCategory(tempCat, {
    'called_from': 'init'
  });

  function gotoCategory(arg, pargs) {


    var margs = {
      'called_from': 'default'
    };


    if (pargs) {
      margs = jQuery.extend(margs, pargs);
    }

    //console.error('gotoCategory() -', arg, margs);

    if (currCatNr > -1 && ccat.find('.gallery-precon').eq(currCatNr).find('.videogallery').eq(0).get(0) != undefined && ccat.find('.gallery-precon').eq(currCatNr).find('.videogallery').eq(0).get(0).external_handle_stopCurrVideo != undefined) {


      var ind = 0;
      ccat.find('.gallery-precon').each(function () {


        //console.info(jQuery(this));
        if (ind != arg) {

          jQuery(this).find('.videogallery').eq(0).get(0).external_handle_stopCurrVideo();
        }
        ind++;
      })


    }
    ccat.find('.gallery-precon').removeClass('curr-gallery');
    ccat.find('.the-categories-con').find('.a-category').removeClass('active');
    ccat.find('.the-categories-con').find('.a-category').eq(arg).addClass('active');
    ccat.find('.gallery-precon').addClass('disabled');
    ccat.find('.gallery-precon').eq(arg).css('display', '').removeClass('disabled');

    var _cach = ccat.find('.gallery-precon').eq(arg);
    var _cachg = _cach.find('.videogallery').eq(0);

    //console.info('_cach - ',_cach);
    //console.info('_cachg - ',_cachg);

    if (_cachg.get(0) && _cachg.get(0).init_settings) {

      //console.info('_cachg.get(0).init_settings - ',_cachg.get(0).init_settings.autoplay);

      if (_cachg.get(0).init_settings.autoplay == 'on') {
        setTimeout(function () {

          _cachg.get(0).api_play_currVideo();
        }, 10);

        if (margs.called_from == 'deeplink' || margs.called_from == 'init') {

          setTimeout(function () {

            //_cachg.get(0).api_play_currVideo();
          }, 1000);
          setTimeout(function () {

            _cachg.get(0).api_play_currVideo();
          }, 1500);
        }
      }
    }

    setTimeout(function () {
      ccat.children('.dzsas-second-con').hide();
      ccat.children('.dzsas-second-con').eq(arg).show();


      //console.info(ccat.find('.gallery-precon').eq(arg));

      ccat.find('.gallery-precon').eq(arg).addClass('curr-gallery');


      currCatNr = arg;

      //console.log(ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0));
      if (typeof ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0) != 'undefined' && typeof ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize != 'undefined') {
        ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize();
        ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize_currVideo();
      }
      setTimeout(function () {

        jQuery(window).trigger('resize');
      }, 1500);


    }, 50);


  }

}
exports.youtube_sanitize_url_to_id = function (arg) {


  if (arg) {

    if (String(arg).indexOf('youtube.com/embed') > -1) {
      var auxa = String(dataSrc).split('youtube.com/embed/');
      //console.info(auxa);

      if (auxa[1]) {

        return auxa[1];
      }
    }

    if (arg.indexOf('youtube.com') > -1 || arg.indexOf('youtu.be') > -1) {


      if (helpersDZSVG.get_query_arg(arg, 'v')) {
        return helpersDZSVG.get_query_arg(arg, 'v');
      }

      if (arg.indexOf('youtu.be') > -1) {
        var arr = arg.split('/');

        arg = arr[arr.length - 1];
      }
    }
  }


  return arg;
}

exports.htmlEntities = function (str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

exports.registerAuxjQueryExtends = function ($) {


  Math.easeIn = function (t, b, c, d) {

    return -c * (t /= d) * (t - 2) + b;

  };
  Math.easeOut = function (t, b, c, d) {
    t /= d;
    return -c * t * (t - 2) + b;
  };


  $.fn.prependOnce = function (arg, argfind) {
    var _t = $(this) // It's your element


//        console.info(argfind);
    if (typeof (argfind) == 'undefined') {
      var regex = new RegExp('class="(.*?)"');
      var auxarr = regex.exec(arg);


      if (typeof auxarr[1] != 'undefined') {
        argfind = '.' + auxarr[1];
      }
    }


    // we compromise chaining for returning the success
    if (_t.children(argfind).length < 1) {
      _t.prepend(arg);
      return true;
    } else {
      return false;
    }
  };
  $.fn.appendOnce = function (arg, argfind) {
    var _t = $(this) // It's your element


    if (typeof (argfind) == 'undefined') {
      var regex = new RegExp('class="(.*?)"');
      var auxarr = regex.exec(arg);


      if (typeof auxarr[1] != 'undefined') {
        argfind = '.' + auxarr[1];
      }
    }
//        console.info(_t, _t.children(argfind).length, argfind);
    if (_t.children(argfind).length < 1) {
      _t.append(arg);
      return true;
    } else {
      return false;
    }
  };
}

exports.dzsvgExtraWindowFunctions = function () {


  window.dzsvg_wp_send_view = function (argcthis, argtitle) {
    // console.info('window.dzsvg_wp_send_view() -5 ', argcthis, argtitle);


    var data = {
      video_title: argtitle
      , video_analytics_id: argcthis.attr('data-player-id')
    };

    if (window.dzsvg_curr_user) {
      data.dzsvg_curr_user = window.dzsvg_curr_user;
    }

    var theajaxurl = 'index.php?action=ajax_dzsvg_submit_view';

    if (window.dzsvg_site_url) {
      theajaxurl = dzsvg_settings.dzsvg_site_url + theajaxurl;
    }


    jQuery.ajax({
      type: "POST",
      url: theajaxurl,
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Ajax - submit view - ' + response);
        }


      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.warn('Got this from the server: ' + arg);
        }
        ;
      }
    });


  }


  window.dzsvg_wp_send_contor_60_secs = function (argcthis, argtitle) {

    var data = {
      video_title: argtitle
      // ,video_analytics_id: argcthis.attr('data-analytics-id')
      , video_analytics_id: argcthis.attr('data-player-id')
      , dzsvg_curr_user: window.dzsvg_curr_user
    };
    var theajaxurl = 'index.php?action=ajax_dzsvg_submit_contor_60_secs';

    if (window.dzsvg_site_url) {

      theajaxurl = dzsvg_settings.dzsvg_site_url + theajaxurl;
    }


    jQuery.ajax({
      type: "POST",
      url: theajaxurl,
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Ajax - submit view - ' + response);
        }


      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.warn('Got this from the server: ' + arg);
        }
        ;
      }
    });
  }


  window.dzsvg_open_social_link = function (arg) {
    var leftPosition, topPosition;
    var w = 500, h = 500;


    // console.info('arg - ',arg);
    arg = arg.replace(/{{replacewithcurrurl}}/g, encodeURIComponent(window.location.href));
    console.warn('arg - ', arg);
    //Allow for borders.
    leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
    //Allow for title and status bars.
    topPosition = (window.screen.height / 2) - ((h / 2) + 50);
    var windowFeatures = "status=no,height=" + h + ",width=" + w + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
    window.open(arg, "sharer", windowFeatures);
  }


  window.dzsvp_yt_iframe_ready = function () {

    _global_youtubeIframeAPIReady = true;
  }

  window.onYouTubeIframeAPIReady = function () {
    window.dzsvp_yt_iframe_ready();
  }


  window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
  })();

}


exports.extractOptionsFromPlayer = function ($c) {

  // console.log('$c - ', $c);
  if($c.data('originalPlayerAttributes')){
    return $c.data('originalPlayerAttributes');
  }
  var finalOptions = {};

  if($c.attr('data-sourcevp')){
    finalOptions.source = $c.attr('data-sourcevp');
  }
  if($c.attr('data-type')){
    finalOptions.type = $c.attr('data-type');
  }

  return finalOptions;
}
exports.convertPluginOptionsToFinalOptions = function (elThis, defaultOptions, argOptions = null, searchedAttr = 'data-options') {

  var finalOptions = null;
  var tempOptions = {};
  var sw_setFromJson = false;
  var _elThis = jQuery(elThis);

  if (argOptions && typeof argOptions == 'object') {
    tempOptions = argOptions;
  } else {

    if (_elThis.attr(searchedAttr)) {
      try {
        tempOptions = JSON.parse(_elThis.attr(searchedAttr));
        sw_setFromJson = true;
      } catch (err) {
        // console.log('err - ', err);
      }
    }
    if (!sw_setFromJson) {

      if (typeof argOptions == 'undefined' || !argOptions) {
        if (typeof _elThis.attr(searchedAttr) != 'undefined' && _elThis.attr(searchedAttr) != '') {
          var aux = _elThis.attr(searchedAttr);
          aux = 'var aux_opts = ' + aux;
          eval(aux);
          tempOptions = Object.assign({}, aux_opts);
        }
      }
    }
  }

  finalOptions = Object.assign(defaultOptions, tempOptions);

  return finalOptions;
}

exports.playerHandleDeprecatedAttrSrc = function (cthis) {


  if (!cthis.attr('data-sourcevp')) {
    if (cthis.attr('data-source')) {
      cthis.attr('data-sourcevp', cthis.attr('data-source'));
    } else {

      if (cthis.attr('data-src')) {
        cthis.attr('data-sourcevp', cthis.attr('data-src'));

      }
    }
  }
}
exports.configureAudioPlayerOptionsInitial = function (cthis, o, selfClass) {
  // console.warn('o.first_video_from_gallery - ',o.first_video_from_gallery, (is_safari()));
  if (is_mobile() || (o.first_video_from_gallery == 'on' && (is_safari()))) {
    if (is_mobile()) {
      cthis.addClass('is-mobile');
    }
    if (cthis.attr('data-img')) {
    } else {
      cthis.removeClass('hide-on-paused');
    }
    if ((o.first_video_from_gallery == 'on' && (is_safari()))) {

      o.autoplay_on_mobile_too_with_video_muted = 'on';
    }
    // console.info('o.autoplay_on_mobile_too_with_video_muted - ',o.autoplay_on_mobile_too_with_video_muted);
    if (cthis.hasClass('is-ad') === false) {
    } else {
      o.autoplay_on_mobile_too_with_video_muted = 'on'
    }
    if (o.autoplay_on_mobile_too_with_video_muted == 'on') {
    } else {
      // console.info("is mobile , chrome , safari / disable autoplay");
      selfClass.autoplayVideo = 'off';
    }
    // o.autoplay='off';
  }

  // console.info('autoplay - ',autoplay);


  //console.info(cthis, o.responsive_ratio);

//            console.info(Number(o.playfrom));


  if (o.playfrom == 'default') {
    if (typeof cthis.attr('data-playfrom') != 'undefined' && cthis.attr('data-playfrom') != '') {
      o.playfrom = cthis.attr('data-playfrom');
    }
  }
  if (isNaN(Number(o.playfrom)) == false) {
    o.playfrom = Number(o.playfrom);
  }


  cthis.data('embed_code', o.embed_code);


  if (o.videoWidth == 0) {
    selfClass.videoWidth = cthis.width();
  } else {
    selfClass.videoWidth = o.videoWidth;
  }

  if (o.videoHeight == 0) {
    selfClass.videoHeight = cthis.height();
  } else {
    selfClass.videoHeight = o.videoHeight;
  }

  // console.info('o.autoplay - ',o.autoplay);

  if (o.autoplay == 'on') {
    selfClass.autoplayVideo = 'on';
  }

  var mainClass = '';
  if (typeof (cthis.attr('class')) == 'string') {
    mainClass = cthis.attr('class');
  } else {
    mainClass = cthis.get(0).className;
  }

  if (mainClass.indexOf('skin_') == -1) {
    cthis.addClass(o.design_skin);
    mainClass += ' ' + o.design_skin;
  }


  cthis.addClass(o.extra_classes);
  //console.info('scrubbar width - ',cthis, o.design_scrubbarWidth);
  //-setting skin specific vars
  if (mainClass.indexOf('skin_aurora') > -1) {
    o.design_skin = 'skin_aurora';
    selfClass.bufferedWidthOffset = -2;
    selfClass.volumeWidthOffset = -2;
    if (o.design_enableProgScrubBox == 'default') {
      o.design_enableProgScrubBox = 'on';
    }
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -113;
    }
  }
  if (mainClass.indexOf('skin_pro') > -1) {
    o.design_skin = 'skin_pro';

    selfClass.volumeWidthOffset = -2;
    if (o.design_enableProgScrubBox == 'default') {
      o.design_enableProgScrubBox = 'off';
    }
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = 0;
    }
  }
  if (mainClass.indexOf('skin_bigplay') > -1) {
    o.design_skin = 'skin_bigplay';
  }
  if (mainClass.indexOf('skin_nocontrols') > -1) {
    o.design_skin = 'skin_nocontrols';
  }
  if (mainClass.indexOf('skin_bigplay_pro') > -1) {
    o.design_skin = 'skin_bigplay_pro';
  }
  if (mainClass.indexOf('skin_bluescrubtop') > -1) {
    o.design_skin = 'skin_bluescrubtop';

    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = 0;
    }
  }
  if (mainClass.indexOf('skin_avanti') > -1) {
    o.design_skin = 'skin_avanti';

    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -125;
    }
  }
  if (mainClass.indexOf('skin_noskin') > -1) {
    o.design_skin = 'skin_noskin';
  }


  if (cthis.hasClass('skin_white')) {
    o.design_skin = 'skin_white';
  }
  if (cthis.hasClass('skin_reborn')) {
    o.design_skin = 'skin_reborn';
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -312;

    }
  }


//                    console.info(o.design_scrubbarWidth);
  if (o.design_scrubbarWidth == 'default') {
    o.design_scrubbarWidth = -201;
  }

  // console.log('is_mobile - ',is_mobile, this);
  if (is_mobile() || is_ios()) {
    cthis.addClass('disable-volume');

    if (o.design_skin == 'skin_reborn') {
      o.design_scrubbarWidth += 65;
    }
  }


  if (o.gallery_object) {
    if (o.gallery_object.get(0)) {
      cthis.get(0).gallery_object = o.gallery_object.get(0);
    }
  }


  if (o.extra_controls) {
    cthis.append(o.extra_controls);
  }



  selfClass.shouldStartMuted = o.autoplay == 'on' && o.autoplay_on_mobile_too_with_video_muted == 'on';
  if (cthis.hasClass('start-muted')) {
    o.defaultvolume = 0;
    o.autoplay_on_mobile_too_with_video_muted = 'on';
    selfClass.shouldStartMuted = true;
  }


  if (o.responsive_ratio == 'default' || (selfClass.dataType == 'youtube' && o.responsive_ratio == 'detect')) {

    if (cthis.attr('data-responsive_ratio')) {
      o.responsive_ratio = cthis.attr('data-responsive_ratio');
    }
  }

  if(o.gallery_object!==null){
    selfClass.isPartOfAnGallery = true;
  }
  if(selfClass.isPartOfAnGallery){
    selfClass.isGalleryHasOneVideoPlayerMode = o.gallery_object.data('vg_settings') && o.gallery_object.data('vg_settings').mode_normal_video_mode=='one';
  }


  // -- we cache this for the one
  if(selfClass.isGalleryHasOneVideoPlayerMode){
    if(o.gallery_target_index===0 && !(selfClass.cthis.data('originalPlayerAttributes'))){
      selfClass.cthis.data('originalPlayerAttributes', this.detect_videoTypeAndSourceForElement(selfClass.cthis));
    }
  }


  this.reinitPlayerOptions(selfClass,o);
}


exports.reinitPlayerOptions = function(selfClass, o){
  // -- we need  selfClass.dataType and selfClass.dataSrc beforeHand


  selfClass.hasCustomSkin = true;
  // -- assess custom skin
  if(selfClass.dataType=='vimeo' && o.vimeo_is_chromeless!=='on'){
    selfClass.hasCustomSkin = false;
  }
  if(selfClass.dataType=='youtube' && o.settings_youtube_usecustomskin==='on'){
    selfClass.hasCustomSkin = false;
  }
  if(this.is_ios() && o.settings_ios_usecustomskin !== 'on'){
    selfClass.hasCustomSkin = false;
  }
  // -- assess custom skin END
}

exports.tagsSetupDom = function (_tagElement) {
  var auxhtml = _tagElement.html();
  var w = 100;
  var h = 100;
  var acomlink = '';
  if (_tagElement.attr('data-width') != undefined) {
    w = _tagElement.attr('data-width');
  }
  if (_tagElement.attr('data-height') != undefined) {
    h = _tagElement.attr('data-height');
  }
  if (_tagElement.attr('data-link') != undefined) {
    acomlink = '<a href="' + _tagElement.attr('data-link') + '"></a>';
  }

  _tagElement.html('');
  _tagElement.css({'left': (_tagElement.attr('data-left') + 'px'), 'top': (_tagElement.attr('data-top') + 'px')});
  //console.log(_tagElement);
  _tagElement.append('<div class="tag-box" style="width:' + w + 'px; height:' + h + 'px;">' + acomlink + '</div>');
  _tagElement.append('<span class="tag-content">' + auxhtml + '</span>');
  _tagElement.removeClass('dzstag-tobe').addClass('dzstag');
  //_tagElement.remove();
}
exports.pauseDzsapPlayers = function () {
  if (window.dzsap_list) {
    for (var i = 0; i < dzsap_list.length; i++) {

      //                    console.info(!is_ie8(), dzsap_list[i].get(0), typeof dzsap_list[i].get(0)!="undefined", typeof dzsap_list[i].get(0).api_pause_media!="undefined")
      if (typeof dzsap_list[i].get(0) != "undefined" && typeof dzsap_list[i].get(0).api_pause_media != "undefined" && dzsap_list[i].get(0) != cthis.get(0)) {

        //console.info('try to pause', dzsap_list[i].get(0),dzsap_list[i].data('type_audio_stop_buffer_on_unfocus'))
        if (dzsap_list[i].data('type_audio_stop_buffer_on_unfocus') && dzsap_list[i].data('type_audio_stop_buffer_on_unfocus') == 'on') {
          dzsap_list[i].get(0).api_destroy_for_rebuffer();
        } else {

          dzsap_list[i].get(0).api_pause_media({
            'audioapi_setlasttime': false
          });
        }
        window.dzsap_player_interrupted_by_dzsvg = dzsap_list[i].get(0);
      }
    }

  }

}
exports.init_navigationOuter = function () {
  jQuery('.videogallery--navigation-outer').each(function () {
    var _t = jQuery(this);


    var xpos = 0;
    _t.find('.videogallery--navigation-outer--bigblock').each(function () {
      var _t = jQuery(this);
      _t.css('left', xpos + '%');
      xpos += 100;
    })

    // console.warn('_t.attr(\'data-vgtarget\') -',_t.attr('data-vgtarget'));


    // -- we will use first gallery if id is auto
    if (_t.attr('data-vgtarget') == '.id_auto') {


      var _cach = jQuery('.videogallery,.videogallery-tobe').eq(0);
      // console.info('jQuery(\'.videogallery\').eq(0) - ',_cach.eq(0));

      var cclass = /id_(.*?) /.exec(_cach.attr('class'));

      if (cclass && cclass[1]) {
        _t.attr('data-vgtarget', '.id_' + cclass[1]);
      }

      if (_cach.get(0) && _cach.get(0).api_set_outerNav) {
        _cach.get(0).api_set_outerNav(_t);
      }
      setTimeout(function () {
        if (_cach.get(0) && _cach.get(0).api_set_outerNav) {
          _cach.get(0).api_set_outerNav(_t);
        }
      }, 1000)
    }
    var _tar = jQuery(_t.attr('data-vgtarget')).eq(0);


    var _clip = _t.find('.videogallery--navigation-outer--clip').eq(0);
    var _clipmover = _t.find('.videogallery--navigation-outer--clipmover').eq(0);

    var currPage = 0;
    var _block_active = _t.find('.videogallery--navigation-outer--bigblock.active').eq(0);
//        console.info(_tar);

    var _navOuterBullets = _t.find('.navigation-outer--bullet');
    var _navOuterBlocks = _t.find('.videogallery--navigation-outer--block');

    setTimeout(function () {
      _t.addClass('active');
      _block_active = _t.find('.videogallery--navigation-outer--bigblock.active').eq(0);
      _clip.height(_block_active.height());
    }, 500)

    _navOuterBlocks.bind('click', function () {
      var _t2 = jQuery(this);
      var ind = _navOuterBlocks.index(_t2);


//            console.info(ind);

      if (_tar.get(0) && _tar.get(0).api_gotoItem) {
        if (_tar.get(0).api_gotoItem(ind)) {
        }


        jQuery('html, body').animate({
          scrollTop: _tar.offset().top
        }, 300);
      }
    });

    _navOuterBullets.bind('click', function () {
      var _t2 = jQuery(this);
      var ind = _navOuterBullets.index(_t2);

      gotoPage(ind);

    })

    function gotoPage(arg) {
      var auxl = -(Number(arg) * 100) + '%';

      _navOuterBullets.removeClass('active');
      _navOuterBullets.eq(arg).addClass('active');

      _t.find('.videogallery--navigation-outer--bigblock.active').removeClass('active');
      _t.find('.videogallery--navigation-outer--bigblock').eq(arg).addClass('active');


      _clip.height(_t.find('.videogallery--navigation-outer--bigblock').eq(arg).height());

      _clipmover.css('left', auxl);

    }


  })
}
exports.init_secondCon = function () {
  jQuery('.dzsas-second-con').each(function () {
    var _t = jQuery(this);


    // -- bug fix: isolated bug.. wp rocket
    var _c = _t;


    if (_c.find('.item').eq(1).children('.menudescriptioncon').html()) {

    } else {

      if (_c.find('.item').eq(2).children('.menudescriptioncon').html()) {

        _c.find('.item').eq(1).remove();
      }
    }

    var xpos = 0;
    _t.find('.videogallery--navigation-outer--bigblock').each(function () {
      var _t = jQuery(this);
      _t.css('left', xpos + '%');
      xpos += 100;
    })


    var xpos = 0;
    _t.find('.item').each(function () {
      var _t2 = jQuery(this);
      _t2.css('left', xpos + '%');
      xpos += 100;
    })


    // console.warn('_t.attr(\'data-vgtarget\') -',_t.attr('data-vgtarget'));


    // -- we will use first gallery if id is auto
    if (_t.attr('data-vgtarget') == '.id_auto') {


      var _cach = jQuery('.videogallery,.videogallery-tobe').eq(0);
      // console.info('jQuery(\'.videogallery\').eq(0) - ',_cach.eq(0));

      var cclass = /id_(.*?) /.exec(_cach.attr('class'));

      if (cclass && cclass[1]) {
        _t.attr('data-vgtarget', '.id_' + cclass[1]);
      }

      if (_cach.get(0) && _cach.get(0).api_set_secondCon) {
        _cach.get(0).api_set_secondCon(_t);
      }
      setTimeout(function () {
        if (_cach.get(0) && _cach.get(0).api_set_secondCon) {
          _cach.get(0).api_set_secondCon(_t);
        }
      }, 1000)
    }
    var _tar = jQuery(_t.attr('data-vgtarget')).eq(0);


  })

}
exports.vimeo_do_command = function (selfClass, vimeo_data, vimeo_url) {

  if (vimeo_url) {

    //console.info(vimeo_url);
    if (selfClass._videoElement && selfClass._videoElement.contentWindow && vimeo_url) {

      selfClass._videoElement.contentWindow.postMessage(JSON.stringify(vimeo_data), vimeo_url);
    }
  }
}
exports.dash_setupPlayer = function (selfClass) {

  var dash_player = null
    , dash_context = null
  ;
  // console.warn("Reading from source ", selfClass.dataSrc);


  function setup_dash() {

    dash_context = new Webm.di.WebmContext();
    dash_player = new MediaPlayer(dash_context);
    dash_player.startup();
    dash_player.attachView(video);

    if (selfClass.autoplayVideo == 'on') {
      dash_player.setAutoPlay(true);
    } else {
      dash_player.setAutoPlay(false);
    }
    dash_player.attachSource(selfClass.dataSrc);
  }

  if(!(selfClass && selfClass.dataSrc)){
    console.log('[dzsvg][error] no selfclass ? ');
    return false;
  }

  if (window.Webm) {

    setup_dash();


    //console.info(selfClass._videoElement.naturalWidth);
  } else {


    var baseUrl = '';
    var baseUrl_arr = helpersDZSVG.get_base_url_arr();
    for (var i24 = 0; i24 < baseUrl_arr.length - 1; i24++) {
      baseUrl += baseUrl_arr[i24] + '/';
    }
    //var src = scripts[scripts.length-1].src;


    var url = baseUrl + 'dash.js';
    //console.warn(scripts[i23], baseUrl, url);
    jQuery.ajax({
      url: url,
      dataType: "script",
      success: function (arg) {
        //console.info(arg);

        setup_dash();


      }
    });
  }
}

exports.playlistGotoItemHistoryChangeForLinks = function(ind_ajaxPage, o, cgallery, _currentTargetPlayer) {


  var $ = jQuery;
  // --- history API ajax cool stuff
  if (o.settings_enableHistory == 'on' && helpersDZSVG.can_history_api()) {
    var stateObj = {foo: "bar"};
    history.pushState(stateObj, "Gallery Video", helpersDZSVG.getDataOrAttr(_currentTargetPlayer, 'data-sourcevp'));

    //jQuery('.history-video-element').load(_currentTargetPlayer.attr('data-sourcevp') + ' .history-video-element');

    $.ajax({
      url: helpersDZSVG.getDataOrAttr(_currentTargetPlayer, 'data-sourcevp'),
      success: function (response) {
        if (window.console != undefined) {
          console.info('Got this from the server: ' + response);
        }
        setTimeout(function () {
          //console.log(jQuery(response).find('.history-video-element').eq(0).get(0).innerHTML);

          $('.history-video-element').eq(0).html($(response).find('.history-video-element').eq(0).html());

          $('.toexecute').each(function () {
            var _t = $(this);
            if (_t.hasClass('executed') == false) {
              eval(_t.text());
              _t.addClass('executed');
            }
          });


          if (o.settings_ajax_extraDivs != '') {
            var extradivs = String(o.settings_ajax_extraDivs).split(',');
            for (let i = 0; i < extradivs.length; i++) {
              //console.log(extradivs[i], jQuery(response).find(extradivs[i]));
              $(extradivs[i]).eq(0).html(jQuery(response).find(extradivs[i]).eq(0).html());
            }
          }

          //console.log(jQuery(response)); console.log(jQuery('.toexecute'));
          //jQuery('.history-video-element').eq(0).get(0).innerHTML = jQuery(response).find('.history-video-element').eq(0).get(0).innerHTML;
          //eval(jQuery('.toexecute').text());
        }, 100);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        if (window.console != undefined) {
          console.error('not found ' + ajaxOptions);
        }
        ind_ajaxPage++;
        cgallery.children('.preloader').fadeOut('slow');

      }
    });

  }
}
exports.playlistGotoItemHistoryChangeForNonLinks = function(margs, o, cid, arg){

  var $ = jQuery;

  var deeplink_str = String(window.dzsvg_settings.deeplink_str).replace('{{galleryid}}', cid);
  if (margs.ignore_linking == false && o.settings_enable_linking == 'on' && margs.called_from != 'init') {
    var stateObj = {foo: "bar"};
    if ($('.videogallery').length == 1) {
      history.pushState(stateObj, null, this.add_query_arg(window.location.href, deeplink_str, (arg)));
    } else {

      history.pushState(stateObj, null, this.add_query_arg(window.location.href, deeplink_str + '-' + cid, (arg)));
    }
  }
}
exports.assertVideoFromGalleryAutoplayStatus = function(currNr, o, cgallery){
  var shouldVideoAutoplay = false;
  if (currNr == -1) {
    if (o.autoplay == 'on') {

      shouldVideoAutoplay = !(cgallery.parent().parent().parent().hasClass('categories-videogallery'));
      shouldVideoAutoplay = !!(cgallery.parent().parent().parent().hasClass('categories-videogallery') && !cgallery.parent().parent().hasClass('gallery-precon'));
      shouldVideoAutoplay = !!(cgallery.parent().parent().parent().hasClass('categories-videogallery') && cgallery.parent().parent().hasClass('gallery-precon') && cgallery.parent().parent().hasClass('curr-gallery'));
    }

  }

  //-- if it's not the first video
  if (currNr > -1) {
    if (o.autoplayNext == 'on') {
      shouldVideoAutoplay = true;
      // -- todo: sideeffect - maybe move
      o.videoplayersettings['cueVideo'] = 'on';
    }
  }



  return shouldVideoAutoplay;
}
/**
 * setup video here .. setup_video
 * @param selfClass
 * @param pargsForVideoSetup
 * @returns {boolean}
 */
exports.generatePlayerMarkupAndSource = function (selfClass, pargsForVideoSetup) {
  var argsForVideoSetup = {
    'preload': 'auto',
    'called_from': 'default',
    'is_dash': false,
    'useCrossOrigin': false,
    'usePlayInline': true,
    'useAudioDimensions': true,
    isGoingToChangeMedia: false,
    is360: false,
    Dzsvg360: null, // -- add the 360 class here if need be

  };

  if (pargsForVideoSetup) {
    argsForVideoSetup = Object.assign(argsForVideoSetup, pargsForVideoSetup);
  }


  var o = selfClass.initOptions;

  // console.log('selfClass - ', selfClass);
  // console.log('this - ', this);

  var struct_video_element = '';

  var usePoster = false;
  var posterSourceStr = '';
  var str_crossorigin = ' crossorigin="anonymous"';


  if (selfClass.cthis.attr('data-img')) {
    usePoster = true;
    posterSourceStr = ' poster="' + selfClass.cthis.attr('data-img') + '"';
  }

  var shouldAutoplay = false;


  if (selfClass.autoplayVideo == 'on' && o.settings_mode != 'videowall') {
    shouldAutoplay = true;
  }

  // -- local video
  // -- if we have user action on page it's enough for autoplay with sound
  if (o.old_curr_nr > -1) {
    if (o.autoplay_on_mobile_too_with_video_muted == 'on') {
      if (1) {
        if (o.autoplay == 'on') {
          o.autoplay_on_mobile_too_with_video_muted = 'off';
        }
      }
    }
  }


  if(argsForVideoSetup.isGoingToChangeMedia){
    selfClass._vpInner.find('.fullscreen-video-element').remove();
    selfClass._vpInner.find('.video-element').remove();
  }



  if (selfClass.dataType == 'selfHosted') {

    if (is_safari()) {
      if (argsForVideoSetup.preload == 'metadata') {
        argsForVideoSetup.preload = 'auto';
      }
    }


    if (o.is_ad == 'on' && is_mobile()) {
      argsForVideoSetup.preload = 'metadata';
    }


    if (is_ios() && o.settings_ios_usecustomskin == 'off') {
      // console.warn("WE ENTER HERE is_ios no custom skin");
      argsForVideoSetup.preload = 'auto';
    }

    struct_video_element = '<video class="the-video video-element" preload="' + argsForVideoSetup.preload + '" ';

    if (this.is_autoplay_and_muted(selfClass.autoplayVideo, o)) {
      // console.info('MUTE IT', cthis);
      struct_video_element += ' muted';

    }

    if (o.touch_play_inline == 'on' || argsForVideoSetup.usePlayInline) {
      struct_video_element += ' webkit-playsinline playsinline';
    } else {
      struct_video_element += ' controls="false"';
    }

    if (argsForVideoSetup.useCrossOrigin) {
      struct_video_element += str_crossorigin;
    }

    if (selfClass.videoWidth != 0) {
      struct_video_element += ' width="100%"';//struct_video_element += ' width="' + videoWidth + '"';
      struct_video_element += ' height="100%"';//struct_video_element += ' height="' + videoHeight + '"';
    }
    struct_video_element += '></video>';

  }
  if (selfClass.dataType == 'audio') {

    struct_video_element = '<audio class="the-video video-element" preload="' + argsForVideoSetup.preload + '" ';
    if (argsForVideoSetup.useAudioDimensions) {

      struct_video_element += ' width="100%"';
      struct_video_element += ' height="100%"';
    }
    struct_video_element += '>';

    if (selfClass.dataSrc) {
      struct_video_element += '<source src="' + selfClass.dataSrc + '" type="audio/mp3"/>'
    }
    struct_video_element += '</audio>';
  }


  if (selfClass.dataType == 'youtube') {

    var youtubeAPIArgs = {};
    selfClass._vpInner.children('.cmedia-con').remove();


    struct_video_element = '<span class="cmedia-con youtube-player-con"><span class="video-element" id="the-media-' + selfClass.currentPlayerId + '"></span></span>';


    if (o.cueVideo == 'off') {
      // o.autoplay='off';
      selfClass.autoplayVideo = 'off';
    }
    //console.info(o.settings_suggestedQuality);


    var playfrom = '';


    if (o.playfrom != 'default') {

//                    console.info(the_player_id, o.playfrom);

      // -- setup last position youtube
      if (o.playfrom == 'last' && the_player_id != '') {
        if (typeof Storage != 'undefined') {
          if (typeof localStorage['dzsvp_' + the_player_id + '_lastpos'] != 'undefined') {
            playfrom = (Number(localStorage['dzsvp_' + the_player_id + '_lastpos']))
            // console.error("GOT HERE");
          }
        }
      }

      if (isNaN(Number(o.playfrom)) == false) {
        playfrom = Number(o.playfrom);
      }
    }


    // -- custom controls
    // -- youtube no controls


    var vol = '';

    var param_autoplay = 0;
    //console.log(o);
    if (shouldAutoplay) {
      param_autoplay = 1
    }

    var playerVars = {
      'autoplay': param_autoplay,
      controls: 0,
      'showinfo': 0,
      'playsinline': 1,
      rel: 0,
      autohide: 1,
      start: playfrom,
      wmode: 'transparent',
      iv_load_policy: 3,
      modestbranding: 1,
      enablejsapi: 1,
      disablekb: 1
    };

    const shouldMute = o.autoplay == 'on' && o.cue == 'on' && o.autoplay_on_mobile_too_with_video_muted == 'on';
    // console.log('shouldMute - ', shouldMute);
    if (shouldMute) {
      playerVars.mute = 1;
    }

    // console.info('playervars 2 3- ', playerVars);

    youtubeAPIArgs = {
      height: '100%',
      width: '100%',
      // origin: 'http://devsite',
      playerVars: playerVars,//, 'playsinline' : 0, enablejsapi : 1
      videoId: selfClass.dataSrc,
      suggestedQuality: o.settings_suggestedQuality,
      events: {
        'onReady': youtube_onPlayerReady
        , 'onStateChange': youtube_onPlayerStateChange
        , 'onPlaybackQualityChange': onPlayerPlaybackQualityChange
      }
    };


    if (argsForVideoSetup.youtube_useDefaultSkin) {
      // -- init ready controls, not custom skin ( default skin )
      selfClass._vpInner.children(':not(.cover-image)').remove();
      youtubeAPIArgs.playerVars.controls = 1;
    }
  }


  /**
   * vimeo
   */
  if (selfClass.dataType == 'vimeo') {

    //_c.children().remove();
    var src = selfClass.dataSrc;
    var str_autoplay = '';

    if (shouldAutoplay) {
      str_autoplay = '&autoplay=1';
      selfClass.cthis.find('.cover-image').fadeOut('fast');
    }


    if (selfClass._vpInner && o.vimeo_is_chromeless != 'on') {
      selfClass._vpInner.children('.controls').remove();
    }
    //console.info(autoplay, o.autoplay);

    //&title=0&byline=0&portrait=0&badge=0

    // console.log("LOADED VIMEO VIA normal IFRAME");

    // -- <div class="fullscreen-video-element"> todo : we do not need for now

    var str_allowFullscreen = 'webkitAllowFullScreen mozallowfullscreen allowFullScreen';
    // str_allowFullscreen = ' ';
    // -- ;fullscreen

    var str_source = 'https:' + '//player.vimeo.com/video/' + src + '?api=1&color=' + o.vimeo_color + '&title=' + o.vimeo_title + '&byline=' + o.vimeo_byline + '&portrait=' + o.vimeo_portrait + '&badge=' + o.vimeo_badge + '&player_id=vimeoplayer' + src + str_autoplay;

    // console.log('[vimeo][construct] str_autoplay - ', str_autoplay);
    struct_video_element = '<div class="fullscreen-video-element"><iframe allow="autoplay;fullscreen" class="vimeo-iframe video-element from-simple" scrolling="no" src="' + str_source + '" width="100%" height="100%" frameborder="0" '+str_allowFullscreen+' style=""></iframe></div>';


  }

  selfClass._fullscreenVideoElement = null;
  selfClass._vpInner.prepend(struct_video_element);


  if (selfClass.dataType == 'vimeo') {
    selfClass._videoElement = selfClass._vpInner.find('.vimeo-iframe').get(0);
    selfClass._fullscreenVideoElement = selfClass._vpInner.find('.fullscreen-video-element').get(0);
  }
  if (selfClass.dataType == 'youtube') {
    // console.log('youtubeAPIArgs - ', youtubeAPIArgs);
    selfClass._videoElement = new YT.Player('the-media-' + selfClass.currentPlayerId, youtubeAPIArgs);
  }
  if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
    selfClass._videoElement = selfClass.cthis.find('.video-element').get(0);
  }

  if(!selfClass._fullscreenVideoElement){
    selfClass._fullscreenVideoElement = selfClass._videoElement;
  }

  if (argsForVideoSetup.is_dash == true) {
    return false;
  }


  if (selfClass.dataType == 'audio') {

    // return false;
    if (selfClass.cthis.attr('data-sourceogg') != undefined) {
      jQuery(selfClass._videoElement).eq(0).append('<source src="' + selfClass.cthis.attr('data-sourceogg') + '" type="audio/ogg"/>');
    }
    if (selfClass.cthis.attr('data-sourcewav') != undefined) {
      jQuery(selfClass._videoElement).eq(0).append('<source src="' + selfClass.cthis.attr('data-sourcewav') + '" type="audio/wav"/>');
    }
  }
  if (selfClass.dataType == 'vimeo') {


    var self2 = this;
    // console.info('_controlsDiv - ',_controlsDiv);

    // console.log('[dzsvg] [vimeo] fullscreen_status() - ',fullscreen_status());

    selfClass._videoElement.addEventListener("webkitfullscreenchange", function (e) {
      if (fullscreen_status() == -1) {
        jQuery(e.target).parent().parent().removeClass('is_fullscreen is-fullscreen');
      }
      ;
    }, false);
    selfClass._videoElement.addEventListener("fullscreenchange", function (e) {
      if (fullscreen_status() == -1) {
        jQuery(e.target).parent().parent().removeClass('is_fullscreen is-fullscreen');
      }
      ;
    }, false);


    if (window.dzsvg_fullscreen_counter) {
      clearInterval(window.dzsvg_fullscreen_counter);
    }

    window.dzsvg_fullscreen_counter = setInterval(function () {


      // -- leave fullscreen event will not trigger in iframe so we need workaround
      // console.info('fullscreen_status() - ',fullscreen_status());
      if (fullscreen_status() != 1) {
        // -- not fullscreen
      } else {
        if (jQuery('.is_fullscreen').length == 0) {
          jQuery('.vplayer.currItem').addClass('is_fullscreen');
        }
        // console.info('curr fullscreen - ',$('.is_fullscreen'),window.dzsvg_fullscreen_curr_video,$('.is_fullscreen').get(0));


        if (window.dzsvg_fullscreen_curr_video && window.dzsvg_fullscreen_curr_video != jQuery('.is_fullscreen').get(0)) {
          console.log(" FOUND DIFFERENCE");
          // $('.is_fullscreen').get(0).requestFullScreen();


          var elem = jQuery('.is_fullscreen').get(0);

          if (jQuery(elem).hasClass('type-vimeo')) {

            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }

          }

        }

        window.dzsvg_fullscreen_curr_video = jQuery('.is_fullscreen').get(0);
      }
    }, 1000);



    if (selfClass.dataType == 'vimeo') {


      function vimeo_addListeners(){
        if (window.Vimeo) {
          clearInterval(_global_vimeoIframeAPILoading_inter);
          _global_vimeoIframeAPIReady = true;


          if (selfClass._videoElement) {
            // console.info(_cmedia);

            // -- vimeo events

            var player = new Vimeo.Player(selfClass._videoElement);


            // console.log('player - ', player);
            player.on('play', function () {
              // console.log('[dzsvg][vimeo] play -2')
              selfClass.playMovie_visual()
            });

            player.on('pause', function () {
              selfClass.pauseMovie_visual();
            });


            // console.info('[log] add fullscreen change event');
            selfClass._videoElement.addEventListener('fullscreenchange', selfClass.fullscreenHandleChange, false);
            selfClass._videoElement.addEventListener('webkitfullscreenchange', selfClass.fullscreenHandleChange, false);
          }

        }

      }


      if (window.Vimeo) {
        vimeo_addListeners()
      }else{

        this.load_outside_script(ConstantsDzsvg.VIMEO_IFRAME_API);

        // console.info("ADDED");


        _global_vimeoIframeAPILoading = true;
        _global_vimeoIframeAPILoading_inter = setInterval(function () {
          vimeo_addListeners();
          // console.info(_global_vimeoIframeAPIReady);
        }, 500);
      }
    }

  }
  if (selfClass.dataType == 'selfHosted') {

    if ((selfClass.dataSrc) && argsForVideoSetup.is_dash == false) {
      if (selfClass.dataSrc && (selfClass.dataSrc.indexOf('.ogg') > -1 || selfClass.dataSrc.indexOf('.ogv') > -1)) {
        selfClass.cthis.attr('data-sourceogg', selfClass.dataSrc);
      }
    }


    if ((selfClass.dataSrc) && argsForVideoSetup.is_dash == false) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.dataSrc + '"/>');
    }


    if (selfClass.cthis.attr('data-sourceogg') != undefined) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.cthis.attr('data-sourceogg') + '" type="video/ogg"/>');
    }
    if (selfClass.cthis.attr('data-sourcewebm') != undefined) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.cthis.attr('data-sourcewebm') + '" type="video/webm"/>');
    }
  }


//                        console.info(o, cthis.attr('data-sourceflash'));


  if (argsForVideoSetup.is360) {
    argsForVideoSetup.Dzsvg360.initPlayer(selfClass);
  }


  function youtube_onPlayerReady(e) {

    if (selfClass._videoElement && selfClass._videoElement.getPlaybackQuality) {
      // console.info('getPlaybackQuality - ', selfClass._videoElement.getPlaybackQuality(), ' | state - ','player ready', ' | quality levels - ',selfClass._videoElement.getAvailableQualityLevels() );


      selfClass._videoElement.setPlaybackQuality(o.settings_suggestedQuality);
    }

    // console.info('yt player ready -8 ', 'o.autoplay_on_mobile_too_with_video_muted - ', o.autoplay_on_mobile_too_with_video_muted);

    // console.log('selfClass.shouldStartMuted - ', selfClass.shouldStartMuted);
    if (selfClass.shouldStartMuted) {

      selfClass.volume_mute();

      selfClass.is_muted_for_autoplay = true;
    }


    // console.warn('o.playfrom - ',o.playfrom);
    // console.warn('autoplay - ',selfClass.autoplayVideo);
    if (o.playfrom == 'last') {
      // TODO: dunno why we need this

      if (selfClass.autoplayVideo == 'off') {

        setTimeout(function () {

          selfClass.pauseMovie({
            'called_from': 'playfrom last'
          });
        }, 1000)
      }
    }


    return false;
    //console.info(selfClass._videoElement.getOptions('cc'));
    selfClass._videoElement.unloadModule('cc'); // For AS3.
    selfClass._videoElement.unloadModule('captions'); // For HTML5.
    selfClass._videoElement.unloadModule("captions");  //Works for AS3 ignored by html5
    selfClass._videoElement.setOption("captions", "track", {"languageCode": "en"});


  }


  function youtube_onPlayerStateChange(e) {

    /*
               -1 – unstarted
               0 – ended
               1 – playing
               2 – paused
               3 – buffering
               5 – video cued
               */

    // console.log('%c youtube_onPlayerStateChange', ConstantsDzsvg.DEBUG_STYLING, 'e - ',e);

    if (e.data == 1) {
      // -play
      //console.log(paused);
      //if(paused){ playMovie(); }


      // console.info("PLAYED..");
      // console.info(has_ad_to_play);


      if (selfClass.queue_goto_perc) {
        selfClass.seek_to_perc(selfClass.queue_goto_perc);
        selfClass.queue_goto_perc = '';
      }


      if (selfClass.ad_status == 'waiting_for_play') {
        selfClass.setup_skipad();
      }

      selfClass.check_if_ad_must_be_played();
      selfClass.check_if_hd_available();

      if (selfClass.youtube_queue_change_quality) {

        selfClass._videoElement.setPlaybackQuality(o.settings_suggestedQuality);
        selfClass.youtube_queue_change_quality = '';
      }

      selfClass.playMovie_visual();
      selfClass.paused = false;
      selfClass.wasPlaying = true;

      selfClass.initial_played = true;


      if (is_mobile()) {
        selfClass.cthis.find('.controls').eq(0).css('pointer-events', 'auto');

      }

    }
    if (e.data == 2) {
      // pause

      if (selfClass.suspendStateForLoop == false) {

        selfClass.pauseMovie({
          'called_from': 'state_2_for_youtube'
        });
      }
      selfClass.paused = true;
      selfClass.wasPlaying = false;
    }

    if (selfClass._videoElement && selfClass._videoElement.getPlaybackQuality) {
      // console.info('getPlaybackQuality - ', selfClass._videoElement.getPlaybackQuality(), ' | state - ',e.data, ' | quality levels - ',selfClass._videoElement.getAvailableQualityLevels() );
    }


    if (e.data == 3) {

      // -- on player play, set the volume again
      selfClass.volume_setInitial();

    }
    if (e.data == 5) {


    }
    if (e.data == 0) {

      // -- handlevideo end
      selfClass.handleVideoEnd();
    }
  }


  function onPlayerPlaybackQualityChange(e) {

    // console.info('onPlayerPlaybackQualityChange', cthis, e.data, e);

  }

}

exports.exitFullscreen = function(){
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }

  return null;
}
exports.requestFullscreen = function(elem){
  console.log('request fullscreen -- ', elem);
  if(elem){

    if (elem.requestFullScreen) {
      return elem.requestFullScreen();
    } else if(elem.webkitRequestFullScreen){
      return elem.webkitRequestFullScreen()
    } else if(elem.mozRequestFullScreen){
      return elem.mozRequestFullScreen()
    }
  }

  return null;
}

exports.load_outside_script = function(arg){

  // -- vimeo api
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = arg;
  head.appendChild(script);
}